import { ReactElement } from "react";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import moment from "moment";
import { Grid, IconButton, List, ListItem, ListItemText, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { formatNumber, isAdmin } from "../../util/util";
import Image from "../SampleImage";

interface Props {
  fileInfo: any
  onClick?: () => void;
  onDeleteClick?: () => void;
}

function SampleImageCard({ fileInfo, onClick, onDeleteClick }: Props): ReactElement {
  const { admin } = useSelector((state: any) => state.adminAuth);

  const handleClick = (event: any) => {
    if (onClick) onClick();
  }

  const handleDeleteClick = (event: any) => {
    if (!onDeleteClick) return;

    event.stopPropagation();
    event.preventDefault();
    onDeleteClick();
  };

  return (
    <Grid container sx={styles.container} onClick={handleClick}>
      <Grid item xs={5}>
        <Image
          id={fileInfo.id}
          alt={fileInfo.name}
          style={styles.image}
        />
      </Grid>
      <Grid item xs={7}>
        <List dense>
          <ListItem sx={styles.usageStatus}>
            {fileInfo.is_used ? (
              <Typography color="primary">{T("mng_sample_images_used")}</Typography>
            ) : isAdmin(admin) ? (
              <IconButton onClick={handleDeleteClick}>
                <DeleteIcon color="error" />
              </IconButton>
            ) : <></>}
          </ListItem>
          <ListItem><ListItemText>{fileInfo.name}</ListItemText></ListItem>
          <ListItem><ListItemText>{formatNumber(fileInfo.size / 1024)}KB</ListItemText></ListItem>
          <ListItem><ListItemText>{moment(fileInfo.updated_at).format("YYYY/MM/DD HH:mm")} {T("mng_sample_images_updated_at")}</ListItemText></ListItem>
        </List>
      </Grid>
    </Grid>
  );
};
export default SampleImageCard;

const styles = {
  container: {
    position: "relative",
    display: "flex",
    "& .MuiList-root": {
      paddingTop: 0
    },
    "& .MuiListItem-root": {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0
    }
  },
  image: {
    width: "100%",
    objectFit: "contain"
  },
  usageStatus: {
    justifyContent: "right",
    minHeight: "1.5rem",
    "& .MuiIconButton-root": {
      padding: 0
    }
  }
}
